import React, { useContext, useEffect, useState, useRef } from "react";
import "./otp.scss";
import abs1 from "../../assets/Group39264.png";
import abs2 from "../../assets/white39265.png";
import { postRequest } from "../../utils/axiosrequest";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Header3 from "../../components/Header/Header3";
import UserContext from "../../context/UserContext";
import { useAuth } from "../../ProtectedRoute/AuthContext";

const OTP = () => {
  const { handleLogin } = useAuth();
  const navigate = useNavigate();

  const location = useLocation();
  const userMobile = location?.state?.phone_no;
  let formatedMobileNo = "******" + userMobile.slice(-4);

  useEffect(() => {
    document.title = "OTP | Ballers";
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const token = "Bearer YmFsbGVyc29mZmljaWFsbGl2ZXdlYnNpdGV0b2tlbjIwMjQ=";

  const [otp, setOTP] = useState(["", "", "", "", "", ""]);
  const [Code, setCode] = useState("+91");
  const [User, setUser] = useState({
    country_code: Code,
    otp: "",
    phone_no: userMobile,
  });
  const inputRefs = useRef([]);

  const [isVerifying, setIsVerifying] = useState(false); // Loading state for OTP verification

  const handleChange = (index, value) => {
    if (!isNaN(value) && value !== "") {
      const newOTP = [...otp];
      newOTP[index] = value;
      setOTP(newOTP);
      setUser({ ...User, otp: newOTP.join("") });
      if (index < otp.length - 1) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && index > 0 && otp[index] === "") {
      inputRefs.current[index - 1].focus();
    } else if (e.key === "Backspace" && otp[index] !== "") {
      const newOTP = [...otp];
      newOTP[index] = "";
      setOTP(newOTP);
      setUser({ ...User, otp: newOTP.join("") });
    }
  };

  const handleVerifyOTP = async (e) => {
    e.preventDefault();

    if (User.otp.length < 6) {
      toast.error("Please enter a valid 6-digit OTP");
      return;
    }

    setIsVerifying(true); // Set loading state to true

    const endpoint = `memberships/verify_otp`; // Ensure base URL includes /api/v1/

    // Only send the required fields as per Swagger
    const payload = {
      country_code: User.country_code,
      phone_no: User.phone_no,
      otp: User.otp,
    };

    try {
      const res = await postRequest(endpoint, payload, token);
      // console.log(res, "resss");
      // Adjust response handling based on actual API response structure
      if (res?.data?.token) {
        const { access_token, flag } = res.data.token;

        // Check if res.detail exists, fallback to a generic message if not
        // toast.success(res.detail || "OTP verified successfully");
        handleLogin(access_token, flag);

        // Determine navigation path based on screen width
        navigate("/dashboard/booking");

        // Reset user state
        setUser({
          ...User, // Keep other fields if needed
          otp: "", // Only reset OTP
        });
      } else {
        toast.error(res.response.data.detail);
      }
    } catch (error) {
      console.error("An error occurred:", error);
      // Handle specific error messages from API if available
      const errorMessage =
        error.response?.data?.detail || "An error occurred while verifying OTP";
      toast.error(errorMessage);
    } finally {
      setIsVerifying(false); // Reset loading state to false
    }
  };

  const handleResetOTP = async () => {
    const endpoint = `auth/member_login`;

    try {
      setOTP(["", "", "", "", "", ""]);
      const res = await postRequest(endpoint, User, token);
      // console.log(res, "resss");
      if (res) {
        setUser({
          ...User,
          country_code: Code,
          phone_no: userMobile,
        });
        // toast.success(res.detail);
        navigate("/verifyOTP", { state: { phone_no: User.phone_no } });
        setResendTimer(180);
        setStartTimer(true);
      }
    } catch (error) {
      console.error("An error occurred:", error);
      toast.error("An error occurred while processing your request.");
    }
  };

  const [resendTimer, setResendTimer] = useState(180);
  const [startTimer, setStartTimer] = useState(true);

  useEffect(() => {
    let timer;
    if (startTimer && resendTimer > 0) {
      timer = setInterval(() => {
        setResendTimer((prevTimer) => (prevTimer > 0 ? prevTimer - 1 : 0));
      }, 1000);
    }

    return () => clearInterval(timer);
  }, [startTimer, resendTimer]);

  const minutes = Math.floor(resendTimer / 60);
  const seconds = resendTimer % 60;

  return (
    <div className="request_section">
      <div className="request_content">
        <Header3 />
        <div className="form" style={{ marginTop: "6rem" }}>
          <div className="title">
            <h2>
              <div className="abs1">
                <img src={abs1} alt="" />
              </div>
              One Membership <br /> Unlimited Sports
              <p className="breakLineSignUp"></p>
            </h2>
            <div className="info">
              <div className="rectangle"></div>
              <p>
                Play. Compete. Socialize. Anytime. Anywhere.
                <div className="abs2">
                  <img src={abs2} alt="" />
                </div>
              </p>
            </div>
          </div>
          <div className="form_wrapper">
            <form>
              <p className="otpHeader">Almost there...</p>
              <p className="otpText">
                Please enter the 6-digit OTP that we just sent on +91{" "}
                {formatedMobileNo}
              </p>
              <div className="otpMain">
                <div className="otp-container">
                  {otp.map((digit, index) => (
                    <input
                      key={index}
                      ref={(ref) => (inputRefs.current[index] = ref)}
                      type="text"
                      className="otp-input"
                      maxLength="1"
                      value={digit}
                      onChange={(e) => handleChange(index, e.target.value)}
                      onKeyDown={(e) => handleKeyDown(index, e)}
                    />
                  ))}
                </div>
              </div>
              <div className="otpBottomDiv">
                {resendTimer === 0 ? (
                  <p className="resendOtp" onClick={handleResetOTP}>
                    Resend OTP
                  </p>
                ) : (
                  <p className="resendOtp">
                    Resend OTP in {minutes < 10 ? `0${minutes}` : minutes}:
                    {seconds < 10 ? `0${seconds}` : seconds}
                  </p>
                )}
              </div>
              <button
                type="button"
                onClick={handleVerifyOTP}
                disabled={isVerifying}
              >
                Login
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OTP;
